import {
  selectHasPermitionMaster,
  selectIsAuth,
} from '@features/auth/store/auth.selectors';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export interface ProtectedRouteProps {
  children: ReactNode;
  requirePermissionMaster?: boolean;
}

export const ProtectedRoute = ({
  children,
  requirePermissionMaster,
}: ProtectedRouteProps) => {
  const isAuth = useSelector(selectIsAuth);
  const hasPermissionMaster = useSelector(selectHasPermitionMaster);

  const isPermitedRoute = requirePermissionMaster ? hasPermissionMaster : true;

  if (!isAuth) {
    return <Navigate to='/login' replace />;
  }

  if (!isPermitedRoute) {
    return <Navigate to='/dashboard' replace />;
  }

  return <>{children}</>;
};
